import { render } from "./AdresseLivraisonView.vue?vue&type=template&id=dded1628&scoped=true"
import script from "./AdresseLivraisonView.vue?vue&type=script&lang=js"
export * from "./AdresseLivraisonView.vue?vue&type=script&lang=js"

import "./AdresseLivraisonView.vue?vue&type=style&index=0&id=dded1628&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dded1628"]])

export default __exports__